var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeopleCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 80,
    viewBox: "0 0 79 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_14532_170751)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 55,
    height: 56,
    rx: 8,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 12.5,
    width: 52,
    height: 53,
    rx: 6.5,
    stroke: "#0089EC",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5 44.174H52.634C52.6371 42.6949 52.1041 41.2647 51.1338 40.1483C50.1635 39.0319 48.8215 38.3049 47.3563 38.1019C45.8911 37.899 44.402 38.2338 43.1648 39.0444C41.9275 39.8549 41.0258 41.0864 40.6267 42.5107C42.1402 43.4563 43.3887 44.7709 44.2548 46.3313C45.1209 47.8916 45.5764 49.6464 45.5784 51.431H43.7123V51.4075C43.7085 49.1077 42.7914 46.9036 41.1628 45.2798C39.5341 43.656 37.3272 42.7456 35.0274 42.7487C32.7276 42.7518 30.5232 43.6682 28.899 45.2964C27.2747 46.9246 26.3636 49.1312 26.3661 51.431H24.5C24.4969 49.7097 24.9161 48.014 25.7209 46.4925C26.5258 44.971 27.6917 43.6702 29.1163 42.7042C30.541 41.7382 32.1809 41.1365 33.8923 40.952C35.6036 40.7674 37.3341 41.0056 38.932 41.6456C39.5308 39.8445 40.7514 38.3156 42.375 37.3326C43.9986 36.3497 45.9192 35.9769 47.7926 36.2812C49.666 36.5855 51.3699 37.5469 52.599 38.9931C53.828 40.4394 54.5019 42.2761 54.5 44.174V44.174ZM42.1938 30.8788C42.1938 30.0264 42.4466 29.1931 42.9202 28.4844C43.3937 27.7756 44.0669 27.2232 44.8544 26.8969C45.642 26.5707 46.5085 26.4854 47.3446 26.6517C48.1807 26.818 48.9486 27.2284 49.5514 27.8312C50.1542 28.4339 50.5647 29.2019 50.731 30.0379C50.8973 30.874 50.8119 31.7406 50.4858 32.5281C50.1596 33.3157 49.6071 33.9888 48.8984 34.4624C48.1896 34.936 47.3563 35.1888 46.5039 35.1888C45.9379 35.1889 45.3774 35.0774 44.8545 34.8608C44.3316 34.6442 43.8564 34.3267 43.4562 33.9265C43.056 33.5263 42.7385 33.0512 42.5219 32.5282C42.3053 32.0053 42.1938 31.4449 42.1938 30.8788V30.8788ZM44.0688 30.8788C44.0688 31.3604 44.2116 31.8312 44.4792 32.2317C44.7467 32.6321 45.127 32.9442 45.5719 33.1285C46.0169 33.3128 46.5065 33.361 46.9788 33.2671C47.4512 33.1731 47.885 32.9412 48.2256 32.6007C48.5661 32.2602 48.798 31.8263 48.892 31.354C48.986 30.8816 48.9378 30.392 48.7535 29.9471C48.5692 29.5021 48.2571 29.1218 47.8567 28.8543C47.4563 28.5867 46.9855 28.4439 46.5039 28.4438C45.8583 28.4446 45.2394 28.7013 44.7829 29.1578C44.3264 29.6143 44.0696 30.2333 44.0688 30.8788V30.8788ZM29.513 34.1669C29.513 33.074 29.8371 32.0056 30.4443 31.0969C31.0515 30.1881 31.9146 29.4798 32.9243 29.0616C33.9341 28.6434 35.0452 28.5339 36.1171 28.7471C37.189 28.9604 38.1737 29.4867 38.9465 30.2595C39.7193 31.0323 40.2456 32.0169 40.4588 33.0889C40.672 34.1608 40.5626 35.2719 40.1444 36.2816C39.7261 37.2914 39.0179 38.1544 38.1091 38.7616C37.2004 39.3688 36.132 39.6929 35.0391 39.6929C34.3134 39.6929 33.5948 39.55 32.9243 39.2723C32.2539 38.9946 31.6447 38.5876 31.1316 38.0744C30.6184 37.5613 30.2114 36.9521 29.9337 36.2816C29.656 35.6112 29.513 34.8926 29.513 34.1669V34.1669ZM31.388 34.1669C31.388 34.889 31.6021 35.5949 32.0033 36.1953C32.4045 36.7957 32.9747 37.2637 33.6418 37.54C34.3089 37.8164 35.043 37.8887 35.7512 37.7478C36.4595 37.607 37.11 37.2593 37.6206 36.7487C38.1312 36.2381 38.479 35.5875 38.6198 34.8793C38.7607 34.1711 38.6884 33.437 38.4121 32.7699C38.1358 32.1027 37.6678 31.5325 37.0674 31.1313C36.467 30.7301 35.7612 30.516 35.0391 30.516C34.0711 30.517 33.1431 30.902 32.4586 31.5865C31.7741 32.2709 31.3891 33.1989 31.388 34.1669V34.1669Z",
    fill: "#0089EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_14532_170751",
    x: 0,
    y: 0,
    width: 79,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14532_170751"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_14532_170751",
    result: "effect2_dropShadow_14532_170751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_14532_170751",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleCount);
export default __webpack_public_path__ + "static/media/people-count.c2a49710950656940ea1a253b249a685.svg";
export { ForwardRef as ReactComponent };